import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VModal from 'vue-js-modal'
import i18n from './i18n'
import store from '@/store/store'
import VueSession from 'vue-session'
import VueCookie from 'vue-cookie'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap-icons/font/bootstrap-icons.css'
import '@/filters/common.js'
import '@/filters/lzp.js'
import ApiRequest from './helpers/ApiRequest.js'
import BasicHelper from './helpers/BasicHelper.js'
import ReportHelper from './helpers/ReportHelper.js'
import ZPFormatHelper from './helpers/ZPFormatHelper.js'
import Vuelidate from 'vuelidate'
import Tableview from '@/components/common/tableview/Tableview.vue'
import MultilangInput from '@/components/common/multilanginput/MultilangInput.vue'
import TranslationDomElements from '@/components/common/translationdomelements/TranslationDomElements.vue'
import MessageBox from '@/components/common/messagebox/MessageBox.vue'
import Datepicker from '@/components/common/datepicker/Datepicker.vue'
import SearchChecklist from '@/components/common/searchchecklist/SearchChecklist.vue'
import NumberInput from '@/components/common/numberinput/NumberInput.vue'
import DatepickerRange from '@/components/common/datepicker-range/DatepickerRange.vue';
import LabelTooltip from '@/components/common/labeltooltip/LabelTooltip.vue';

Vue.config.productionTip = false

Vue.use(VModal)
Vue.use(VueSession, { persist: true })
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(Vuelidate)
Vue.use(VueCookie)
Vue.component('Tableview', Tableview)
Vue.component('MultilangInput', MultilangInput)
Vue.component('TranslationDomElements', TranslationDomElements)
Vue.component('MessageBox', MessageBox)
Vue.component('Datepicker', Datepicker)
Vue.component('SearchChecklist', SearchChecklist);
Vue.component('NumberInput', NumberInput);
Vue.component('DatepickerRange', DatepickerRange);
Vue.component('DatepickerRange', DatepickerRange);
Vue.component('LabelTooltip', LabelTooltip);

Vue.prototype.ApiRequest = ApiRequest
Vue.prototype.BasicHelper = BasicHelper
Vue.prototype.ReportHelper = ReportHelper
Vue.prototype.ZPFormatHelper = ZPFormatHelper

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
